import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Battery, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#1a1f3a] text-[#faf8f5] min-h-screen flex items-center overflow-hidden" data-id="element-80">
      {/* Background subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a1f3a] via-[#1f2544] to-[#1a1f3a] opacity-50" data-id="element-81"></div>

      <div className="container mx-auto px-6 py-20 relative z-10" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-83">
          <div className="space-y-8" data-id="element-84">
            <FadeIn data-id="element-85">
              <div className="inline-flex items-center space-x-2 bg-[#ffffff10] px-4 py-2 rounded-full text-[#d4a574] text-sm font-medium mb-6 backdrop-blur-sm border border-[#ffffff10]" data-id="element-86">
                <Battery className="w-4 h-4" data-id="element-87" />
                <span data-id="element-88">Protocolo de 21 días</span>
              </div>
            </FadeIn>

            <FadeIn delay={200} data-id="element-89">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-[#faf8f5]" data-id="element-90">
                De <span className="text-[#d4a574]" data-id="element-91">"batería al 30%"</span> a
                energía estable en 21 días{' '}
                <span className="text-[#8da399] italic text-3xl md:text-4xl block mt-2 font-normal" data-id="element-92">
                  (sin extremos)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={400} data-id="element-93">
              <p className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed" data-id="element-94">
                Si duermes y sigues cansada, no es pereza: es ritmo.
              </p>
            </FadeIn>

            <FadeIn delay={600} data-id="element-95">
              <div className="space-y-6 border-l-2 border-[#d4a574] pl-6 my-8" data-id="element-96">
                <p className="text-lg text-gray-300" data-id="element-97">
                  Hay un tipo de cansancio que no se arregla con "dormir más".
                  Duermes. Te levantas. Y aun así… sientes el cuerpo pesado, la
                  mente lenta y la paciencia en números rojos.
                </p>
                <p className="text-lg text-gray-300" data-id="element-98">
                  Y lo peor: por fuera "estás bien". Cumples. Respondes.
                  Produces. Sonríes cuando toca. Pero por dentro estás operando
                  con la batería al 30%.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={800} data-id="element-99">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-100">
                <Button className="group" onClick={() => document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              })} data-id="element-101">
                  Quiero recuperar energía estable
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-102" />
                </Button>
              </div>
              <p className="mt-4 text-sm text-gray-400" data-id="element-103">
                No necesitas otra lista infinita de hábitos. Necesitas un orden.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={400} className="relative" data-id="element-104">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-[#ffffff10] group" data-id="element-105">
              <div className="absolute inset-0 bg-[#d4a574] opacity-10 group-hover:opacity-20 transition-opacity duration-500" data-id="element-106"></div>
              <img src="https://cdn.magicpatterns.com/uploads/oyf4s7bCwydHgFS9sJ3xLb/GUIA_RAPIDA_ENERGIA.png" alt="Guía de Reinicio de Energía en una mesa de noche acogedora" className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-107" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-[#d4a574] rounded-full filter blur-[100px] opacity-20" data-id="element-108"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-[#8da399] rounded-full filter blur-[100px] opacity-10" data-id="element-109"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}